import {ElementRef, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Router} from "@angular/router";
import {NzMessageService} from "ng-zorro-antd/message";
import {lastValueFrom} from "rxjs";
import {NzTreeNode} from "ng-zorro-antd/tree";

@Injectable({
  providedIn: 'root'
})
export class EchUtils {
  constructor(private http: HttpClient, private router: Router,
              private message: NzMessageService) {
  }

  /**
   * post请求
   * @param url
   * @param data
   * @param headers
   */
  private _postObservable(url: string, data: any = {}, headers = {}) {
    return this.http.post(url, data, {
      headers: new HttpHeaders(headers),
      responseType: 'json',
    });
  }

  /**
   * post请求
   * @param url
   * @param data
   * @param headers
   */
  private async _postAsyncPromise(url: string, data: any = {}, headers = {}) {
    return await lastValueFrom(this.http.post(url, data, {
      headers: new HttpHeaders(headers),
      responseType: 'json',
    }));
  }

  /**
   * post请求
   * @param url
   * @param data
   * @param headers
   */
  postObservable(url: string, data: any = {}, headers = {}) {
    let params: string[] = [];
    for (const key in data) {
      if (data.hasOwnProperty(key) && this.isNotEmpty(data[key])) {
        params.push(key.concat("=").concat(data[key]));
      }
    }
    const _headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      "responseType": 'json'
    };
    Object.assign(headers, _headers);
    return this._postObservable(url, params.join("&"), headers);
  }


  /**
   * post请求
   * @param url
   * @param data
   * @param headers
   */
  async postAsyncPromise(url: string, data: any = {}, headers = {}) {
    let params: string[] = [];
    for (const key in data) {
      if (data.hasOwnProperty(key) && this.isNotEmpty(data[key])) {
        params.push(key.concat("=").concat(data[key]));
      }
    }
    const _headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      "responseType": 'json'
    };
    Object.assign(headers, _headers);
    return await this._postAsyncPromise(url, params.join("&"), headers);
  }

  /**
   * post请求
   * @param url
   * @param success
   * @param err
   * @param data
   * @param headers
   */
  post(url: string, success: (response: any) => void,
       err: (error: any) => void, data: any | undefined | null = {}, headers = {}) {
    let objectObservable = this.postObservable(url, data, headers);
    objectObservable.subscribe({
      next: success,
      error: err,
      complete: () => {
      }
    });
    return objectObservable

  }

  /**
   * 同步请求
   * @param url
   * @param success
   * @param err
   * @param data
   * @param dataType
   */
  async postAsync(url: string, success: (response: any) => void,
                  err: (error: any) => void,
                  data: any | undefined | null = {},
                  headers = {}) {
    await success(await this.postAsyncPromise(url, data, headers));
  }

  /**
   *
   * @param url
   * @param data
   * @param headers
   */
  requestContentTypeOfJsonObservable(url: string,
                                     data: any | undefined | null = {},
                                     headers = {}) {
    const _headers = {'Content-Type': 'application/json'};
    Object.assign(headers, _headers);
    return this._postObservable(url, data, headers);
  }

  /**
   *
   * @param url
   * @param data
   * @param headers
   */
  requestContentTypeOfTextPlainObservable(url: string,
                                          data: any | undefined | null = {},
                                          headers = {}) {
    const _headers = {
      "Content-Type": "text/plain"
    };
    Object.assign(headers, _headers);
    return this._postObservable(url, data, headers);
  }

  /**
   * body方式POST请求
   * @param url
   * @param success
   * @param err
   * @param data
   * @param headers
   */
  requestContentTypeOfJson(url: string, success: (response: any) => void,
                           err: (error: any) => void,
                           data: any | undefined | null = {},
                           headers = {}) {
    let objectObservable = this.requestContentTypeOfJsonObservable(url, data, headers);
    objectObservable.subscribe({
      next: success,
      error: err,
    });
    return objectObservable
  }

  /**
   * body方式POST请求
   * @param url
   * @param success
   * @param err
   * @param data
   * @param headers
   */
  requestContentTypeOfTextPlain(url: string, success: (response: any) => void,
                                err: (error: any) => void,
                                data: any | undefined | null = {},
                                headers = {}) {
    let objectObservable = this.requestContentTypeOfTextPlainObservable(url, data, headers);
    objectObservable.subscribe({
      next: success,
      error: err,
    });
    return objectObservable
  }

  /**
   * 请求数据，如果没权限调到登录
   * @param url
   * @param success
   * @param err
   * @param data
   * @param headers
   */
  requestObservable(url: string, data: any = {}, headers: {} = {}) {
    return this.postObservable(url.concat("?code=").concat(Date.now() + ""), data, headers);
  }

  /**
   * 请求数据，如果没权限调到登录
   * @param url
   * @param success
   * @param err
   * @param data
   * @param headers
   */
  request(url: string,
          success: (response: any) => void,
          err: (error: any) => void, data: any = {}, headers: {} = {}) {
    return this.post(url.concat("?code=").concat(Date.now() + ""), success, (error: any) => {
      console.error(error);
      err(error);
    }, data, headers);
  }

  /**
   * Get请求
   * @param url
   * @param success
   * @param err
   */
  getObservable(url: string) {
    return this.http.get(url);
  }

  /**
   * Get请求
   * @param url
   * @param success
   * @param err
   */
  get(url: string, success: (response: any) => void, err: (error: any) => void) {
    let getObservable = this.getObservable(url);
    getObservable.subscribe({
      next: success,
      error: err,
    });
    return getObservable;
  }

  insert($this: any, index: number, item: any) {
    $this.splice(index, 0, item);
  }

  addAll($this: any, $array: any) {
    if ($array == null || $array.length === 0) {
      return;
    }
    $array.forEach((value: any, index: any, array: any) => {
      $this.push(value);
    });
  }

  isNumber(data: any) {
    if (typeof data === 'undefined' || data == null) {
      return false;
    }
    return !isNaN(data);
  }

  isArray($array: any) {
    try {
      if ($array == null) {
        return false;
      }
      if (!(Array.isArray($array) || toString.apply($array) === '[object Array]')) {
        return false;
      }
    } catch (e) {
      return false;
    }
    return true;
  }

  isEmpty(data: any) {
    if (data instanceof Array) {
      return data.length <= 0;
    } else if (typeof data === 'string') {
      return data.trim() === '';
    } else {
      return data == null || typeof data === 'undefined' ||
        (data.length != null && typeof data.length !== 'undefined' && data.length <= 0);
    }
  }

  isNotEmpty(data: any) {
    return !this.isEmpty(data);
  }

  isNull(v: any, d: any, d2: any) {
    if (this.isEmpty(v)) {
      return d;
    } else {
      return this.isEmpty(d2) ? v : d2;
    }
  }

  formatShort(date: Date) {
    const myyear = date.getFullYear();
    const mymonth = date.getMonth() + 1;
    const myweekday = date.getDate();
    const format = myyear + '-' + (mymonth < 10 ? '0' + mymonth : mymonth) + '-' + (myweekday < 10 ? '0' + myweekday : myweekday);
    return format;
  }

  getLastMonthDate() {
    const lastMonthDate = new Date();  //  上月日期
    lastMonthDate.setDate(1);
    lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
    return lastMonthDate;
  }

  getMonthDays(myMonth: any) {
    const now = new Date();
    const nowYear = now.getFullYear();
    const monthStartDate = new Date(nowYear, myMonth, 1);
    const monthEndDate = new Date(nowYear, myMonth + 1, 1);
    const days = (monthEndDate.getDate() - monthStartDate.getDate()) / (1000 * 60 * 60 * 24);
    return days;
  }

  getQuarterStartMonth() {
    const now = new Date();                    //  当前日期
    const nowMonth = now.getMonth();           //  当前月
    let quarterStartMonth = 0;
    if (nowMonth < 3) {
      quarterStartMonth = 0;
    }
    if (2 < nowMonth && nowMonth < 6) {
      quarterStartMonth = 3;
    }
    if (5 < nowMonth && nowMonth < 9) {
      quarterStartMonth = 6;
    }
    if (nowMonth > 8) {
      quarterStartMonth = 9;
    }
    return quarterStartMonth;
  }

  getYesterday() {
    const now = new Date();                    // 当前日期
    const nowDay = now.getDate();              // 当前日
    const nowMonth = now.getMonth();           // 当前月
    const nowYear = now.getFullYear();             // 当前年
    return new Date(nowYear, nowMonth, nowDay - 1);
  }

  getWeekStartDate() {
    const now = new Date();                    // 当前日期
    const nowDayOfWeek = now.getDay();         // 今天本周的第几天
    const nowDay = now.getDate();              // 当前日
    const nowMonth = now.getMonth();           // 当前月
    const nowYear = now.getFullYear();             // 当前年
    return new Date(nowYear, nowMonth, nowDay - nowDayOfWeek + 1);
  }

  getWeekEndDate() {
    const now = new Date();                    // 当前日期
    const nowDayOfWeek = now.getDay();         // 今天本周的第几天
    const nowDay = now.getDate();              // 当前日
    const nowMonth = now.getMonth();           // 当前月
    const nowYear = now.getFullYear();             // 当前年
    return new Date(nowYear, nowMonth, nowDay + (6 - nowDayOfWeek) + 1);
  }

  getLastWeekStartDate() {
    const now = new Date();                    // 当前日期
    const nowDayOfWeek = now.getDay();         // 今天本周的第几天
    const nowDay = now.getDate();              // 当前日
    const nowMonth = now.getMonth();           // 当前月
    const nowYear = now.getFullYear();             // 当前年
    return new Date(nowYear, nowMonth, nowDay - nowDayOfWeek + 1 - 7);
  }

  getLastWeekEndDate() {
    const now = new Date();                    // 当前日期
    const nowDayOfWeek = now.getDay();         // 今天本周的第几天
    const nowDay = now.getDate();              // 当前日
    const nowMonth = now.getMonth();           // 当前月
    const nowYear = now.getFullYear();             // 当前年
    return new Date(nowYear, nowMonth, nowDay + (6 - nowDayOfWeek) + 1 - 7);
  }

  getDateByDayCount(AddDayCount: any) {
    const dd = new Date();
    dd.setDate(dd.getDate() + AddDayCount);
    return dd;
  }

  getMonthStartDate() {
    const now = new Date();                    // 当前日期
    const nowMonth = now.getMonth();           // 当前月
    const nowYear = now.getFullYear();             // 当前年
    return new Date(nowYear, nowMonth, 1);
  }

  getMonthEndDate() {
    const now = new Date();                    // 当前日期
    const nowMonth = now.getMonth();           // 当前月
    const nowYear = now.getFullYear();             // 当前年
    return new Date(nowYear, nowMonth, this.getMonthDays(nowMonth));
  }

  getLastMonthStartDate() {
    const now = new Date();                    // 当前日期
    const nowMonth = now.getMonth();           // 当前月
    const nowYear = now.getFullYear();             // 当前年
    let year = nowYear;
    if (nowMonth === 0) {
      year = year - 1;
    }
    return new Date(year, this.getLastMonthDate().getMonth(), 1);
  }

  getLastMonthEndDate() {
    const now = new Date();
    const lastMonth = this.getLastMonthDate().getMonth();
    let nowYear = now.getFullYear();             // 当前年
    const nowMonth = now.getMonth();           // 当前月
    if (nowMonth === 0) {
      nowYear = nowYear - 1;
    }
    return new Date(nowYear, lastMonth, this.getMonthDays(lastMonth));
  }

  getQuarterStartDate() {
    const now = new Date();
    const nowYear = now.getFullYear();             // 当前年
    return new Date(nowYear, this.getQuarterStartMonth(), 1);
  }

  getQuarterEndDate() {
    const now = new Date();
    const nowYear = now.getFullYear();
    const quarterEndMonth = this.getQuarterStartMonth() + 2;
    return new Date(nowYear, quarterEndMonth, this.getMonthDays(quarterEndMonth));
  }

  getLastQuarterStartDate() {
    const now = new Date();
    const nowYear = now.getFullYear();             // 当前年
    return new Date(nowYear, this.getQuarterStartMonth() - 3, 1);
  }

  getLastQuarterEndDate() {
    const now = new Date();
    const nowYear = now.getFullYear();             // 当前年
    const quarterEndMonth = this.getQuarterStartMonth() + 2 - 3;
    return new Date(nowYear, quarterEndMonth, this.getMonthDays(quarterEndMonth));
  }

  getYearStartDate() {
    const yearStart = new Date();
    yearStart.setMonth(0); // 设置月份为0（0代表1月）
    yearStart.setDate(1); // 设置日期为1
    yearStart.setHours(0, 0, 0, 0); // 可选：将时间设置为0点
    return yearStart;
  }

  getToDayStartDate() {
    let dayStart = new Date();
    dayStart.setHours(0, 0, 0, 0);
    return dayStart;
  }

  getToDayByYearCount(yearCount: any) {
    const now = new Date();
    const nowYear = now.getFullYear() + yearCount;
    const nowMonth = now.getMonth();
    const day = now.getDate();
    return new Date(nowYear, nowMonth, day);
  }

  getToDayByMonthCount(monthCount: any) {
    const now = new Date();
    const nowYear = now.getFullYear();
    const nowMonth = now.getMonth() + monthCount;
    const day = now.getDate();
    return new Date(nowYear, nowMonth, day);
  }

  getToDayByDayCount(dayCount: any) {
    const now = new Date();
    const nowYear = now.getFullYear();
    const nowMonth = now.getMonth();
    const day = now.getDate() + dayCount;
    return new Date(nowYear, nowMonth, day);
  }

  /**
   * 获取日期格式：yyyy-MM-dd HH:mm:ss
   * @param date
   */
  getDateFormatValue(date: any): any {
    if (typeof date === "string") return date;
    let month = (date.getMonth() + 1).toString().padStart(2, '0');
    let strDate = date.getDate().toString().padStart(2, '0');
    //时间格式yyyy-MM-dd HH:MM:SS
    return `${date.getFullYear()}-${month}-${strDate} ${this.getTimeFormatValue(date)}`;
  }

  /**
   * 获取指定日期的时间格式化
   * @param date
   */
  getTimeFormatValue(date: Date): any {
    if (typeof date === "string") return date;
    //时间格式HH:MM:SS
    let hours = date.getHours().toString().padStart(2, '0');
    let minutes = date.getMinutes().toString().padStart(2, '0');
    let seconds = date.getSeconds().toString().padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  }

  getToday() {
    return new Date();
  }

  copyProperty(o: any) {
    const copyRow: any = {};
    o.forEach((k: any, v: any) => {
      copyRow[k] = v;
    });
    return copyRow;
  }

  clearNoNum(obj: any, attr: any) {
    // 先把非数字的都替换掉
    obj[attr] = obj[attr].replace(/[^\d.]/g, '');
    // 必须保证第一个为数字而不是.
    obj[attr] = obj[attr].replace(/^\./g, '');

  }

  groupByKeyValue(list: any[], key: string): any {
    return Array.from(list.reduce((map, item) => {
      const group = item[key];
      map.set(group, (map.get(group) || []).concat(item));
      return map;
    }, new Map()), ([key, value]) => ({[key]: value}));
  }

  groupListByKey(list: any[], key: string): any {
    let groupList: any = []
    list.forEach((el) => {
      let filter = groupList.filter((f: any) => f.name === el[key]);
      if (filter.length > 0) {
        filter[0].groupItem.push(el);
      } else {
        groupList.push({name: el[key], groupItem: [el]});
      }
    });
    return groupList;
  }

  buildTreeData(id: string, pid: string, data: Array<any>) {
    data.forEach((d => {
      d.children = void (0);
      data.forEach((sub => {
        if (d[id] == sub[pid]) {
          if (!d.children) {
            d.children = new Array<any>();
          }
          d.children.push(sub);
        }
      }))
    }))
    return data.filter(item => item[pid] == undefined);
  }

  unBuildTreeData(children: string, data: any): any[] {
    let dataList: any[] = [];
    data.forEach((d: any) => {
      if (d[children]) {
        dataList.push(...this.unBuildTreeData(children, d[children]))
      }
      dataList.push(d);
    });
    return dataList;
  }

  successMessage(msg: string): void {
    this.message.create("success", msg);
  }

  infoMessage(msg: string): void {
    this.message.create("info", msg);
  }

  warningMessage(msg: string): void {
    this.message.create("warning", msg);
  }

  errorMessage(msg: string): void {
    this.message.create("error", msg);
  }

  loadingMessage(msg: string): void {
    this.message.create("loading", msg);
  }

  setInterval(intervalBean: {
    ms?: number;
    intervalEvent: () => void;
    interval?: number;
    endEvent?: () => void;
  }): void {
    let ms = intervalBean.ms || 10000;
    let interval = intervalBean.interval || 200;
    setTimeout((interval: number) => {
        clearInterval(interval);
        if (intervalBean.endEvent) {
          intervalBean.endEvent();
        }
      }, ms,
      setInterval(() => {
        intervalBean.intervalEvent();
      }, interval));
  }

  resolvingCommonResult(data: any, success: (data: any) => void, error: (msg: string) => void): void {
    try {
      if (data.status) {
        success(data.data);
      } else {
        error(data.message);
      }
    } catch (e: any) {
      error(e);
    }
  }

  isImage(url: string | null) {
    if (url === null)
      return false;
    if (url === undefined)
      return false
    return url.toUpperCase().endsWith("JPG") ||
      url.toUpperCase().endsWith("PNG")
  }

  hasClass(element: ElementRef, className: string) {
    return element.nativeElement.className && new RegExp("\\b" + className + "\\b")
      .test(element.nativeElement.className);
  }

  getParents(node: NzTreeNode | null | undefined) {
    let nzTreeNodes: (NzTreeNode | null | undefined)[] = []
    if (this.isNotEmpty(node?.parentNode)) {
      let pNzTreeNodes = this.getParents(node?.parentNode);
      nzTreeNodes.push(...pNzTreeNodes);
    }
    nzTreeNodes.push(node)
    return nzTreeNodes;
  }

  encodeToBase64Str(str: string): string {
    return btoa(encodeURIComponent(str));// 直接处理 Unicode ‌:ml-citation{ref="2,5" data="citationList"}
  }

// Base64 转字符串
  decodeWithBase64Str(base64Str: string): string {
    return decodeURIComponent(atob(base64Str));// 直接处理 Unicode ‌:ml-citation{ref="2,5" data="citationList"}
  }

  //创建分页
  buildPage(array: any[], pageSize: number): any[][] {
    if(this.isEmpty(array)){
      return [];
    }
    let pages: any[][] = [];
    let page: any[] = [];
    pages.push(page);
    for (let i = 0; i < array.length; i++) {
      if (page.length == pageSize) {
        page = [];
        pages.push(page);
      }
      page.push(array[i]);
    }
    return pages;
  }
}
